"use client";

import React from "react";

const THEMES = {
  pi: {
    btn: "bg-rail-pi hover:bg-rail-piHover text-black border border-black/10",
    badge: "Pi Network",
  },
  base: {
    btn: "bg-rail-coinbase hover:bg-rail-coinbaseHover text-white border border-white/10",
    badge: "Base / Coinbase",
  },
  fogo: {
    btn: "bg-rail-nightly hover:bg-rail-nightlyHover text-white border border-white/10",
    badge: "Nightly Wallet",
  },
  now: {
    btn: "bg-rail-now hover:bg-rail-nowHover text-white border border-white/10",
    badge: "NOWPayments",
  },
  neutral: {
    btn: "bg-surface hover:bg-surfaceElevated text-textPrimary border border-border",
    badge: null,
  },
};

export default function RailButton({
  theme = "neutral",
  loading = false,
  loadingText = "Redirecting…",   // ✅ NEW
  disabled = false,
  onClick,
  children,
  hint,
  badge,
  leftIcon,
  rightIcon,                      // ✅ NEW (optional)
  className = "",
}) {
  const t = THEMES[theme] || THEMES.neutral;

  return (
    <div className="w-full">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        className={[
          "relative w-full h-12 px-4 rounded-xl font-semibold text-sm",
          "flex items-center justify-center gap-2",
          "transition-all duration-200",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "shadow-sm hover:shadow-md hover:-translate-y-[1px]",
          "focus:outline-none focus:ring-2 focus:ring-accent/40",
          t.btn,
          className,
        ].join(" ")}
      >
        {leftIcon ? <span className="absolute left-4">{leftIcon}</span> : null}
        {rightIcon ? <span className="absolute right-4">{rightIcon}</span> : null}

        {loading ? (
          <>
            <span>{loadingText}</span>
            <div className="absolute inset-0 overflow-hidden rounded-xl">
              <div className="h-full w-1/2 bg-white/10 animate-progress" />
            </div>
          </>
        ) : (
          children
        )}
      </button>

      {(hint || badge || t.badge) && (
        <div className="mt-2 flex items-center justify-between text-[11px] text-textSecondary">
          <span>{hint || ""}</span>
          <span className="opacity-80">{badge || t.badge || ""}</span>
        </div>
      )}
    </div>
  );
}
